import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
//import ReactCountryFlag from "react-country-flag";
import { Row, Col, Menu, Modal } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  //CaretDownOutlined,
  UserOutlined,
  //HomeOutlined,
  LogoutOutlined,
  LoginOutlined,
} from "@ant-design/icons";

import * as authActions from "modules/auth/actions";
import { clearFlashMessage, removeUIState } from "modules/ui/actions";

import { translate } from "lib/helper";

import { StyledHearder, MenuHeader } from "styled/common-styled";

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class Header extends Component {
  state = {
    notiCount: 0,
    haveNewNoti: false,
    inputLng: "",
    token: "",
  };

  _isMounted = false;

  onRemoveCredentials = () => {
    this.props.removeCredentials();
    this.props.removeUIState();
  };

  onDismiss = () => {
    this.props.clearFlashMessage();
  };

  componentDidMount() {
    this._isMounted = true;
    let self = this;
    let { tokenExp } = this.props;
    let timeNow = Date.now();

    // if (typeof tokenExp === "undefined" || tokenExp === null || tokenExp === "") {
    //   setTimeout(function() {
    //     self.modal(
    //       translate("notification", "header"),
    //       translate("tokenExpired", "header")
    //     );
    //   }, 500);
    // }
    if (Math.floor(timeNow / 1000) < tokenExp) {
      let diffTime = (tokenExp - Math.floor(timeNow / 1000)) * 1000;
      this.tokenExpTimeout = setTimeout(function () {
        self.modal(
          translate("notification", "header"),
          translate("tokenExpired", "header")
        );
      }, diffTime);
    }

    this.setState({
      inputLng: "th",
    });
  }

  setToken(token) {
    this.setState({
      ...this.state,
      token,
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.tokenExpTimeout);
  }

  checkSelectLang = (inputLng) => {
    this.props.changeLang(inputLng);
    if (inputLng === "en") {
      this.setState({
        inputLng: "us",
      });
    } else {
      this.setState({
        inputLng: "th",
      });
    }
  };

  modal = (title, content) => {
    this.onRemoveCredentials();
    Modal.warning({
      title: title,
      okText: "Ok",
      okType: "default",
      onOk() {
        // window.location.href = "/";
      },
      content: content,
    });
  };

  render() {
    const { done, collapsed, toggle } = this.props;

    //const CheLan = translate("changeLanguage", "header");

    return (
      <Fragment>
        <StyledHearder>
          <div className="space-between-middle">
            <Col xs={{ span: 0 }} sm={8} md={4} lg={4} xl={4}>
              {React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: "trigger",
                  onClick: toggle,
                }
              )}
            </Col>
            <Col sm={16} md={6} lg={6} xl={6}>
              <MenuHeader mode="horizontal" align="right">
                <SubMenu
                  id="sub1"
                  data-cy="user-info"
                  title={
                    <div>
                      <Row align="middle">
                        {" "}
                        <Col xs={24} sm={0} md={0} lg={0} xl={0}>
                          <UserOutlined />
                        </Col>
                      </Row>
                      <Row align="middle">
                        <Col xs={0} sm={24} md={24} lg={24} xl={24}>
                          <UserOutlined />
                          {localStorage.getItem("profile") !== null &&
                            JSON.parse(localStorage.getItem("profile"))
                              .username}
                        </Col>
                      </Row>
                    </div>
                  }
                >
                  <MenuItemGroup title={translate("titleAccount", "header")}>
                    {/* <Menu.Item key="setting:1" style={{ paddingLeft: "14px" }}>
                      <HomeOutlined />
                      {translate("home", "header")}
                      <Link to="/" />
                    </Menu.Item> */}
                    <Menu.Item key="setting:2" style={{ paddingLeft: '14px' }}>
                      <UserOutlined />
                      โปรไฟล์
                      <Link to="/profile" />
                    </Menu.Item>
                    {done ? (
                      <Menu.Item
                        key="menu:1"
                        style={{ paddingLeft: "14px" }}
                        onClick={this.onRemoveCredentials}
                      >
                        <LogoutOutlined />
                        {translate("logout", "header")}
                        <Link data-cy="logout" to="/" />
                      </Menu.Item>
                    ) : (
                      <Menu.Item key="menu:1" style={{ paddingLeft: "14px" }}>
                        <LoginOutlined />
                        {translate("login", "header")}
                        <Link to="/" />
                      </Menu.Item>
                    )}
                  </MenuItemGroup>
                </SubMenu>
              </MenuHeader>
            </Col>
          </div>
        </StyledHearder>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  auth: { accessToken, done, profile, tokenExp },
  ui: { flash, lastestNotificationAt },
}) => ({
  accessToken,
  done,
  profile,
  flash,
  lastestNotificationAt,
  tokenExp,
});
const mapDispatchToProps = {
  removeCredentials: authActions.removeCredentials,
  removeUIState: removeUIState,
  loadCredentials: authActions.loadCredentials,
  clearFlashMessage: clearFlashMessage,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
